import { AVAILABLE_LANGUAGES } from "components/navbar/LanguageSelector";
import useSelfie from "lib/hooks/useSelfie";
import { useRouter } from "next/router";
import { invariant } from "outvariant";

export default function useViewerCountry() {
  const viewer = useSelfie();
  const { locale = "pt-BR" } = useRouter();

  invariant(AVAILABLE_LANGUAGES.includes(locale), `Couldn't match on language for "%s"`, locale);

  if (viewer && viewer.isSiteAdmin) {
    return locale === "pt-BR" ? "BR" : "US";
  }

  return viewer?.country || "BR";
}
